import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarPostagemByIdService } from "../../../services/buscarPostagemByIdService";

export const useBuscarPostagensById = (
  postagemId: number | undefined | null,
  fetch: boolean
) => {
  const [postagem, setPostagem] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as postagem
  useEffect(() => {
    const fetchLead = async () => {
      if (postagemId && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarPostagemByIdService(postagemId);
          if (data) {
            setPostagem(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar Postagem:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [postagemId, fetch]);

  return { postagem, isLoading };
};
